(ns admin.components.composite.curriculum.banner
  (:require
   [re-frame.core :as re-frame]

   [kyber.components.base.link :as link]
   [kyber.components.base.icons :as icons]
   [kyber.components.base.text :as text]
   [kyber.components.composite.toggle :as toggle]
   [kyber.styles.core :refer [gs styles->classes]]

   [admin.events.activities :as >activities]
   [admin.router.utils :as aru]
   [admin.utils :as au]))

(def classes
  (styles->classes
   {:container
    {:padding [(gs [:spacing :p12])
               (gs [:spacing :p20])]
     :background (gs [:colors :primary-lite-800])}

    :align-center
    {:display :flex
     :align-items :center}

    :nav-text
    {:color (gs [:colors :true-white])
     :font-size (gs [:font-size :title-20])
     :font-weight (gs [:font-weight :body-20])
     :margin 0
     :padding [(gs [:spacing :p8])
               (gs [:spacing :p0])]}

    :truncate
    {:overflow :hidden
     :text-overflow :ellipsis
     :white-space :nowrap}

    :nav-link
    {"&:hover"
     {:text-decoration :underline
      :color (gs [:colors :true-white])}}}))

(defn- render-publish-toggle [{:keys [curriculum-uuid]}]
  (let [can-manage-published-state
        (re-frame/subscribe [:authentication/has-access?
                             :activity/can-manage-publish-state
                             {:curriculum-uuid curriculum-uuid}])]
    (fn [{:keys [activity]}]
      (let [{activity-uuid :uuid :keys [published]} activity]
        (when (and (some? activity-uuid)
                   (true? @can-manage-published-state))
          [:div {:class (:align-center classes)}
           [text/title-20 :p {:class (:nav-text classes)
                              :style {:margin-right (gs [:spacing :p12])
                                      :margin-left (gs [:spacing :p24])}}
            "Published?"]
           ;; toggle is not a controlled component, adding key will force a re-render
           ;; if the underlying model is updated.
           [toggle/render
            {:key published
             :default-value published
             :pass-atom-on-change true
             :on-text "Yes"
             :off-text "No"
             :style {:margin 0}
             :on-change (fn [current-value]
                          (re-frame/dispatch
                           [:notifier/create-alert
                            {:title
                             (if (false? @current-value)
                               "Unpublish Activity"
                               "Publish Activity")

                             :message
                             (if (false? @current-value)
                               (str "Unpublishing this activity will make it no longer "
                                    "accessible to learners. Are you sure you want to "
                                    "unpublish it?")
                               (str "Publishing this activity will make it accessible "
                                    "to learners. Are you sure you want to publish it?"))

                             :confirm-text
                             (if (false? @current-value)
                               "Unpublish"
                               "Publish")

                             :confirm-action
                             (fn []
                               (re-frame/dispatch
                                [::>activities/update-activity-v2
                                 {:activity/uuid activity-uuid
                                  :activity/published (true? @current-value)
                                  :curriculum/uuid curriculum-uuid}
                                 identity]))
                             :deny-action #(swap! current-value not)}]))}]])))))

(defn render
  [{:keys [curriculum
           no-curriculum-title
           activity
           route-params
           hide-publish-button]
    :or {hide-publish-button false}}]
  (let [{:keys [activity-uuid curriculum-uuid]}
        route-params

        {curriculum-name :name
         clp-enabled :clp-enabled}
        curriculum

        {activity-name :name
         external-activity-link :external-activity-link}
        activity]
    [:div {:class (:container classes)}
     (cond
       (some? curriculum)
       [:div {:class (:curriculum-banner-container classes)}
        [:div {:class (:align-center classes)}
         [:div  {:class (:align-center classes)}
          [link/link {:href (aru/admin-path :curriculum-selection)
                      :class [(:nav-text classes)
                              (:nav-link classes)
                              (:truncate classes)]
                      :style {:display :block}
                      :title "All Curricula"}
           "Curricula"]
          [:span {:style {:margin-left (gs [:spacing :p12])
                          :margin-right (gs [:spacing :p12])
                          :color (gs [:colors :true-white])
                          :opacity 0.75}}
           "/"]]

         [:div {:style (cond-> {:min-width "0%"}
                         (nil? activity)
                         (assoc :flex-grow 1))}
          (if (some? activity)
            [link/link {:href (aru/admin-path :curriculum-activities
                                              :curriculum-uuid curriculum-uuid)
                        :class [(:nav-text classes)
                                (:nav-link classes)
                                (:truncate classes)]
                        :style {:display :block}
                        :title curriculum-name}
             curriculum-name]

            [text/title-20 :p {:class [(:nav-text classes)
                                       (:truncate classes)]
                               :style {:opacity 0.75}
                               :title curriculum-name}
             curriculum-name])]


         (when (some? activity)
           [:div {:style {:min-width "0%"
                          :flex-grow 1}}

            [text/title-20 :p {:class [(:nav-text classes)
                                       (:truncate classes)]
                               :style {:opacity 0.75
                                       :padding-right :20px}
                               :title activity-name}
             [:<>
              [:span {:style {:margin-left (gs [:spacing :p12])
                              :margin-right (gs [:spacing :p12])}}
               "/"]
              activity-name]]])

         ;; Only show link when on an activity page or the clp is enabled
         [:div {:class (:align-center classes)
                :style {}}
          (when (or (some? activity)
                    (true? clp-enabled))
            [link/transparent-anchor-button
             {:target "_blank"
              :style {:margin-right (gs [:spacing :p12])}
              :href (if-not (empty? external-activity-link)
                      external-activity-link
                      (au/->learner-url
                       (cond-> {:curriculum curriculum-uuid}
                         (some? activity)
                         (assoc :activity activity-uuid))))}
             [:<>
              [icons/icon-sm {:style {:color :inherit
                                      :margin-right (gs [:spacing :p8])}}
               :eye]
              (if (some? activity) "Preview Activity" "Preview Curriculum")]])
          (when (and (some? activity-uuid)
                     (false? hide-publish-button))
            [render-publish-toggle {:activity activity
                                    :curriculum-uuid curriculum-uuid}])]]]

       :else
       [text/title-40 :p {:style {:color (gs [:colors :true-white])}}
        (or no-curriculum-title "Your Curricula")])]))
